import React from 'react';

import { H5 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';

import * as ST from './styled';

interface IProps {
    icon: JSX.Element,
    title: string,
    description: string,
}

const PromoInfoCard = ({ icon, title, description }: IProps) => {
    return (
        <ST.Wrapper>
            <ST.IconWrapper>
                {icon}
            </ST.IconWrapper>
            <TextWrapper>
                <H5>{title}</H5>
                <Paragraph4 dangerouslySetInnerHTML={{ __html: description }}/>
            </TextWrapper>
        </ST.Wrapper>
    );
};

export default PromoInfoCard;
